var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_c('el-button',{attrs:{"type":"text","size":"mini"},on:{"click":_vm.openNewUrl}},[_vm._v("点击查看图片")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }